import React from "react";
import FormGroup from "../../../../../../../../shared/bootstrap/form/form-group/FormGroup";
import { useLanguageForShared } from "../../../../../../../../shared/utils/languages/useLanguageForShared";

const ConcentratorFlowTypeSelector = ({ name, value, changeValue, isSubmit }) => {
  const { t } = useLanguageForShared();

  const translateOrFallback = (key, fallback) => {
    const translated = t(key);
    return translated === key ? fallback : translated;
  };

  const options = [
    { label: translateOrFallback("prescription.template.flowType.pulsed", "Pulsato"), value: "pulsed" },
    { label: translateOrFallback("prescription.template.flowType.continuous", "Continuo"), value: "continuous" }
  ];

  const handleOptionClick = (optionValue) => {
    changeValue({
      name,
      value: value === optionValue ? "" : optionValue
    });
  };

  const hasError = isSubmit && !value;

  return (
    <FormGroup
      label={{ label: `${translateOrFallback("prescription.template.flowType.label", "Tipo flusso")}*` }}
      error={{ isVisible: hasError, message: translateOrFallback("prescription.template.flowType.required", "Campo obbligatorio") }}
    >
      <div className="d-flex flex-wrap gap-4 pt-2">
        {options.map((option) => (
          <label key={option.value} className="d-inline-flex align-items-center mb-0" style={{ cursor: "pointer", gap: "0.5rem" }}>
            <input
              type="radio"
              name={name}
              value={option.value}
              checked={value === option.value}
              onClick={() => handleOptionClick(option.value)}
              onChange={() => {
              }}
            />
            <span>{option.label}</span>
          </label>
        ))}
      </div>
    </FormGroup>
  );
};

export default ConcentratorFlowTypeSelector;